module.exports = __webpack_public_path__ + "img/pr-7.bcd41ff7.png";